import { observer } from "mobx-react-lite";
import notificationsStore from "../../stores/notificationsStore";
import { useEffect } from "react";
import styles from "./Notifications.module.css";
import { format } from "date-fns";

const Notifications = () => {
  const { getNotifications, notifications, updateNotification } =
    notificationsStore;

  useEffect(() => {
    getNotifications();
  }, []);

  const onMarkAsRead = () => {
    updateNotification();
  };

  return (
    !!notifications.length && (
      <div className={styles.modalOverlay}>
        <div className={styles.modal}>
          <div className={styles.modalContent}>
            <h4>Notification!</h4>
            <div className={styles.notificationsBlock}>
              {notifications.map((item, i) => {
                return (
                  <div key={i} className={styles.notificationItem}>
                    <p className={styles.messageText}>{item?.message}</p>
                    <p className={styles.createdDate}>
                      {format(new Date(item?.created_at), "dd/MM/yyyy HH:mm")}
                    </p>
                  </div>
                );
              })}
            </div>
            <button onClick={() => onMarkAsRead()} className={styles.btn}>
              Mark As Read
            </button>
          </div>
        </div>
      </div>
    )
  );
};

export default observer(Notifications);
